"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endsWithMatcherContext = void 0;
var constants_1 = require("../../logger/constants");
var lang_1 = require("../../utils/lang");
function endsWithMatcherContext(log, ruleAttr) {
    return function endsWithMatcher(runtimeAttr) {
        var strEndsWith = ruleAttr.some(function (e) { return (0, lang_1.endsWith)(runtimeAttr, e); });
        log.debug(constants_1.ENGINE_MATCHER_ENDS_WITH, [runtimeAttr, ruleAttr, strEndsWith]);
        return strEndsWith;
    };
}
exports.endsWithMatcherContext = endsWithMatcherContext;
